import fetch from '@/api/fetch'
export default{
    data(){
        return {
            dialogData: {
                titleText: this.$t('accoutNumberAdmin.SCZH'),
                addLxDialog: false,
                dialogWidth: '460px',
                formData:{
                    accountCount: '',
                    schemeId: ''
                },
                buttonLoading: false,
                accountCount: '--',
            },
            
            loading: false,
            seachData:{
                searchContent: '',
                schemeId: ''
            },
            buttonsLoading: false,
            activeList: [],
            playerList: [],
            schemeList: [],
            teamTableHeader:  [
                {prop: 'sortNo', label: this.$t('accoutNumberAdmin.XH'),width: '115'},
                {prop: 'playerName', label: this.$t('accoutNumberAdmin.XM')},
                {prop: 'accountName', label: this.$t('accoutNumberAdmin.ZH')},
                {prop: 'accountPwd', label: this.$t('accoutNumberAdmin.MM')},
                {prop: 'schemeName', label: this.$t('accoutNumberAdmin.GLJH')},
                {prop: 'operation', label: this.$t('accoutNumberAdmin.CZ'),SlotType:{
                    buttons:[
                      {
                        name: this.$t('accoutNumberAdmin.SC'),
                        emitName: 'delete' // 事件Type 必传
                      }
                    ]
                }}
            ],
            total: 0,
            pageNo: 1
        }
    },
    created() {
        this.getPlanSchemeList()
        this.getList()
    },
    watch:{
        'dialogData.addLxDialog'(){
            if(!this.dialogData.addLxDialog){
                this.dialogData.formData = {
                    accountCount: '',
                    schemeId: ''
                }
                this.dialogData.accountCount = '--'
            }
        }
    },
    computed:{
        queryData(){
            return JSON.parse(sessionStorage.getItem('queryData'))
        }
    },
    methods: {
        // 获取大计划列表
        getPlanSchemeList(){
            let { professionId, provinceId, subjectId } = this.queryData
            let params = {
                professionId,
                subjectId,
                provinceId,
            }
            fetch.planSchemeList(params).then(res=>{
                if(res.code == 0){
                    this.schemeList = res.data
                }
            })
        },
        getList(type){
            this.loading = true
            let { professionId, provinceId, subjectId } = this.queryData
            if(type != 'pageNo' && (this.seachData.searchContent || this.seachData.schemeId)){
                this.pageNo = 1
            }
            let params = {
                professionId,
                provinceId,
                subjectId,
                ...this.seachData,
                limitSize: 100,
                pageNo: this.pageNo
            }
            fetch.freeAccountList(params).then(res=>{
                if(res.code == 0){
                    this.total = res.data.total
                    // sortNo: ++index + ( (this.pageNo -1) * 100)
                    this.playerList = res.data.records.map((item, index)=>({sortNo: ((++index) + ( (this.pageNo -1) * 100)), ...item }))
                    this.loading = false
                }else{
                    this.loading = false
                    this.$notify({ title: this.$t('accoutNumberAdmin.CZ'), message: res.msg || this.$t('accoutNumberAdmin.HQLBSB'), type: 'error' });
                }
            })
        },
        accountExport(){
            this.buttonsLoading = true
            let { searchContent, schemeId} = this.seachData
            let { professionId, provinceId, subjectId } = this.queryData
            fetch.accountExport({
                orgId: this.__userData.orgId,
                schemeId,
                professionId,
                subjectId,
                provinceId,
                searchContent
            }).then(res=>{
                let url = window.URL.createObjectURL(new Blob([res],{type: 'UTF-8'}))
                setTimeout(()=>{
                    this.buttonsLoading = false
                }, 1500)
                let link= document.createElement('a')
                link.style.display='none'
                link.href=url
                link.setAttribute('download', this.$t('accoutNumberAdmin.ZHTJB'))    // 自定义下载文件名（如exemple.txt）
                document.body.appendChild(link)
                link.click()
            })
        },
        // 生成账号 
        createdAccout(type){
            if(type === 'next'){
                // 生成账号确认
                
                let { professionId, subjectId } = this.queryData
                let { schemeId, accountCount } = this.dialogData.formData
                if(!schemeId){
                    this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.QXZGLSSJH'), type: 'warning'})
                    return false
                }else if(!accountCount || accountCount <= 0){
                    this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.QSRZHSL'), type: 'warning'})
                    return false
                }else if(isNaN(accountCount)){
                    this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.QSRSZ'), type: 'warning'})
                    return false
                }else if(accountCount > this.dialogData.accountCount){
                    // 大于可生成账号
                    this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.DQJHKSCZHW') + this.dialogData.accountCount, type: 'warning'})
                    return false
                }
                let params = {
                    professionId,
                    schemeId,
                    subjectId,
                    accountCount
                }
                this.dialogData.buttonLoading = true
                fetch.freeAccountCreate(params).then(res=>{
                    if(res.code == '0'){
                        this.dialogData.addLxDialog = false
                        this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.SCZHCG'), type: 'success'})
                        this.getList()
                        this.dialogData.buttonLoading = false
                    }else{
                        this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: res.msg || this.$t('accoutNumberAdmin.SCZHSB'), type: 'error'})
                    }
                })
            }else{
                this.dialogData.addLxDialog = true
            }
        },
        deletePlayer(type, rowData){
            let { professionId, subjectId } = this.queryData
            if(type == 'all'){
                if(this.activeList.length){
                    this.deletePlayerSave({
                        professionId,
                        subjectId,
                        playerKeyIdList: this.activeList.map(item=>item.id),
                        userIdList: this.activeList.map(item=>item.userId)
                    })
                }else{
                    this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.ZSXZYTJXSCCZ'), type: 'warning'})
                    return false
                }
            }else{
                this.deletePlayerSave({
                    professionId,
                    subjectId,
                    playerKeyIdList: [rowData.id],
                    userIdList: [rowData.userId]
                })
            }
            // {professionId:2,schemeId:1,playerKeyIdList:[1,2,3],userIdList:[11,22,33]}
        },
        // 确认删除选手
        deletePlayerSave(params){
            this.$confirm(this.$t('accoutNumberAdmin.QRSCH'), this.$t('accoutNumberAdmin.TS'), {
                confirmButtonText: this.$t('accoutNumberAdmin.QD'),
                cancelButtonText: this.$t('accoutNumberAdmin.QX'),
                type: 'error'
            }).then(() => {
                fetch.freeAccountDelete(params).then(res=>{
                    if(res.code == 0){
                        this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.SCCG'), type: 'success'})
                        this.pageNo = 1
                        this.getList()
                    }else{
                        this.$notify({ title: this.$t('accoutNumberAdmin.CZ'), message: res.msg || this.$t('accoutNumberAdmin.SCSB'), type: 'error' });
                    }
                })
            }).catch(() => {
                this.$notify({title: this.$t('accoutNumberAdmin.CZ'), message: this.$t('accoutNumberAdmin.QXSC'), type: 'info'})
                this.resetRuleData()
            });
        },
        // 获取 计划可创建的账号
        schemeChage(){
            let { professionId,subjectId } = this.queryData
            let params = {
                professionId,
                subjectId,
                schemeId: this.dialogData.formData.schemeId
            }
            fetch.freeAccountGetCount(params).then(res=>{
                if(res.code == 0){
                    this.dialogData.accountCount = res.data.accountCount
                }else{
                    this.$notify({ title: this.$t('accoutNumberAdmin.CZ'), message: res.msg || this.$t('accoutNumberAdmin.CJSB'), type: 'error' });
                }
            })
        },
        operation(type, rowData){
            if(type == 'selectChange'){
                this.activeList = rowData
            }else if(type == 'delete'){
                this.deletePlayer('current', rowData)
            }
        }
    },
}